/* eslint-disable */
export default {
  createCallLog: 'Criar registo de cham.',
  viewInSalesforce: 'Ver no Salesforce',
  createLog: 'Criar registo',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
